import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { ListGroup, ListGroupItem, Label, Input, Row, Col } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';
import Loading from '../../../components/modales/loadingModal';

import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';
import { singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';

const enviarCorreo = functionsHttpsCallable('correos_envioCorreoExamenes');
const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

// Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = state => ({
    usuarioActivo: state
})

const anillos = [
    {
        id: 'ANILLO_AREA_INFLUENCIA',
        name: 'Anillo área de influencia'
    },
    {
        id: 'ANILLO_MUNICIPIO_ALEDANO',
        name: 'Anillo municipio aledaño'
    },
    {
        id: 'ANILLO_DEPARTAMENTAL',
        name: 'Anillo departamental'
    },
    {
        id: 'ANILLO_NACIONAL',
        name: 'Anillo nacional'
    },
]
const ModalPublicacion = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [updFile, setUpdFile] = useState([]);

    const setAnilloActivo = async (nuevoAnillo) => {
        let tempObj = { ...props.data }
        tempObj['anilloReclutamiento'] = nuevoAnillo
        props.setData({ ...tempObj })
        const updateBody = {
            cod_soli: props.id,
            data: {
                anl_vaca: nuevoAnillo
            },

        }
        await actualizarAPE(updateBody)
    }
    // if (loading) { return <div className={"loading-area"}> <Loading /> </div> }
    // else 
    const handleUpload = async () => {
        try {
            props.setLoading(true)
            
            let tempFilesList = props.fileList
            if (updFile.length > 0) {
                for (const file of updFile) {
                    let newFile = await singleFileUploader(file, `APEFiles/${props.id}`, `${file.key}${file.name.substring(file.name.lastIndexOf('.'))}`)
                    tempFilesList.push({ fileName: newFile[0].name })
                }
            }
            props.setFileList(tempFilesList)
            props.setLoading(false)
            props.toastSuccess('Archivo Cargado!')
        }
        catch (error) {
            console.log(error)
            props.toastError('Error al cargar archivo')
        }
    }

    const updateFile = (e) => {
        const tempArr = []
        tempArr.push(e)
        setUpdFile([...tempArr])
    }
    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: 'REMISION'
            },

        }
        try {
            const req = await actualizarAPE(body)
            props.updateAPE({
                estadoAPE: 'REMISION'
            })
            toastSuccess('APE actualizada!')
        }
        catch (error) {
            console.log(error)
            toastSuccess('Hubo un error!')
        }
    }

    const handleStateUpdate = async () => {
        await handleUpload()
        await updateAPE()
        props.toggle()
    }

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                buttonLoading={false}
                secondButton={false}
                title={`Listado Candidatos`}
                onClick={async () => {
                    handleStateUpdate()
                }}
            >
                <ListGroup>
                    {anillos.map((anillo, index) => {
                        console.log(props.data.anilloReclutamiento, anillo.id)
                        if (props.data.anilloReclutamiento == anillo.id) return (
                            <div key={`divG_reclutamiento_${index}`} className='reclutamiento-list-item'>
                                <ListGroupItem key={`lisItem_reclutamiento_${index}`} color="success">
                                    <div key={`div_reclutamiento_${index}`} className='reclutamiento-list-area'>
                                        {anillo.name}
                                        <div className='reclutamiento-list-buttons'>
                                            <div className='reclutamiento-list-buttons-item'>
                                                {/* <AssignedButton disabled={true} /> */}
                                                <Input type="checkbox" checked={true} />
                                                {' '}
                                                <Label check>
                                                    
                                                </Label>
                                            </div>
                                        </div>
                                    </div>
                                </ListGroupItem>

                            </div>
                        )
                        else return (
                            <div key={`divG_reclutamiento_${index}`} className='reclutamiento-list-item'>
                                <ListGroupItem key={`lisItem_reclutamiento_${index}`}>
                                    <div key={`div_reclutamiento_${index}`} className='reclutamiento-list-area'>
                                        {anillo.name}
                                        <div className='reclutamiento-list-buttons'>
                                            <div className='reclutamiento-list-buttons-item'>
                                                {/* <AssignButton tooltip={'Seleccionar candidato'} onClick={() => setCandidatoActivo(candidato.cedula)} /> */}
                                                <Input type="checkbox" checked={false} onChange={() => { setAnilloActivo(anillo.id) }} />
                                                {' '}
                                                <Label check>
                                                    
                                                </Label>
                                            </div>
                                        </div>
                                    </div>
                                </ListGroupItem>

                            </div>)
                    })}
                </ListGroup>
                <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Col lg='3' md='3' xs='12'>
                        <AttachCardV2
                            id={'ANILLO'}
                            subText={`Anillo publicacion`}
                            attached={updFile.length > 0 || fileExist('ANILLO').exists}
                            file={fileExist(`ANILLO`).file}
                            apeId={props.id}
                            fileList={props.fileList}
                            setLoading={(e) => props.setLoading(e)}
                            setFileList={(e) => { props.setFileList(e) }}
                        />
                    </Col>
                    <Col lg='3' md='3' xs='12'>
                        <AttachCardV2
                            id={'CERTIFICADO_INEXISTENCIA'}
                            subText={`Certificado Inexistencia`}
                            attached={updFile.length > 0 || fileExist('CERTIFICADO_INEXISTENCIA').exists}
                            file={fileExist(`CERTIFICADO_INEXISTENCIA`).file}
                            apeId={props.id}
                            fileList={props.fileList}
                            setLoading={(e) => props.setLoading(e)}
                            setFileList={(e) => { props.setFileList(e) }}
                        />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );

}

export default connect(mapStateToProps)(ModalPublicacion);